import { render, staticRenderFns } from "./DocumenttoCustomer.vue?vue&type=template&id=2b95976c&scoped=true"
import script from "./DocumenttoCustomer.vue?vue&type=script&lang=js"
export * from "./DocumenttoCustomer.vue?vue&type=script&lang=js"
import style1 from "./DocumenttoCustomer.vue?vue&type=style&index=1&id=2b95976c&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b95976c",
  null
  
)

export default component.exports